import apiClient from "./apiClient";

//==============Get All Classes==================

export const getClasses = async (id = -1) => {
  const res = await apiClient.get(`/Courses/TAGTypes/${id}`, {
    headers: {
      SchoolID: 11,
    },
  });
  return res.data;
};

//============Get subject by class Id==================

export const getSubjectsByclassId = async (id = -1) => {
  const res = await apiClient.get(`/LiveClasses/GetSubjectsByClass?classId=${id}`, {
    headers: { SchoolID: 11, },
  });
  return res.data;
};

//=============Get Course by class================

export const getCoursesByclassId = async (courseTag)=>
{
  try{
    const response = await apiClient.get(`/LiveClasses/GetCoursesByTag?courseTag=${courseTag}`,
    
    )
     return response.data;

  }
   catch (error) {
    console.error("Get Courses Error:", error);
    throw error;
  }
}

